import { useLocation, useNavigate, useParams } from 'react-router-dom';

/**
 * This is temporary as we migrated to react-router v6 - we need to convert class components to functional.
 * @param Component HOC to provide location, navigate, and params.
 * @returns
 */
export function withRouter(Component: React.ComponentType<any>) {
  return (props: any) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return <Component {...props} location={location} navigate={navigate} params={params} />;
  };
}
